import { registerSW } from 'virtual:pwa-register';
import { toast } from './ui/dom';

/**
 * Service Worker registrieren. Die Web-Version bekommt einen Hinweis, sobald
 * eine neue Fassung bereitsteht; in der Play-Store-Variante (TWA) übernimmt
 * das Update dieselbe Mechanik, weil dort ebenfalls der Browser-Cache greift.
 */
export function registerServiceWorker(): void {
  if (import.meta.env.DEV) return;

  // Die neue Fassung wird bewusst nicht sofort aktiviert: Ein Reload mitten in
  // einer Partie wäre ärgerlich. Der Browser übernimmt sie beim nächsten Start.
  registerSW({
    onNeedRefresh() {
      toast('Neue Version verfügbar – wird beim nächsten Start geladen.', 5000);
    },
    onOfflineReady() {
      toast('Offline spielbereit.', 2500);
    },
  });
}
